import React from 'react';
import { Link } from 'react-router-dom';

interface ISummary {
    id: Number;
}

interface ISummaryProps {
    user: { id: number }
    about: { header: string, description: string, image: string }
}

function Index(props: ISummaryProps) {
    const { user, about } = props;
    return (
        <section id="mc-section-2" className="mc-section-2 section">
            <div className="awe-parallax bg-section1-demo" style={{ backgroundImage: "url(https://lakeshorecancercenter.com.ng/img/parallax-1.jpg)" }} />
            <div className="overlay-color-1" />
            <div className="container">
                <div className="section-2-content">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="ct">
                                <h2 className="big">{about?.header}</h2>
                                <p className="mc-text">{about?.description}</p>
                                {!user?.id &&
                                    <Link to="/auth/register" className="mc-btn btn-style-3">Create Account</Link>}

                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="image">
                                <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + about?.image} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Index;